import { getOWAConnectedAccount } from 'owa-accounts-store';
import { assertNever } from 'owa-assert';
import { getUserMailboxInfo, MailboxInfo, MailboxType } from 'owa-client-ids';
import { lazyGetAndUpdateRefreshToken } from 'owa-headers-refresh-token';
import { isPastTime } from 'owa-observable-datetime';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';

const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';
const HEADER_AUTHORIZATION: string = 'Authorization';
const HEADER_WEBSESSION_TYPE: string = 'X-OwaWebSessionType';

export async function getDefaultRequestHeaders(
    mailboxInfo: MailboxInfo
): Promise<{ [headerName: string]: string }> {
    if (mailboxInfo) {
        switch (mailboxInfo.type) {
            case MailboxType.GroupMailbox:
                return getExplicitLogonHeaders(mailboxInfo.deprecatedMailboxId);
            case MailboxType.UserMailbox:
                let headers: { [headerName: string]: string } = {};

                // for all non-primary, connected accounts, get the token and anchor mailbox from owa-accounts-store
                if (mailboxInfo.primarySmtpAddress != getUserMailboxInfo().primarySmtpAddress) {
                    headers = await getConnectedAccountHeaders(mailboxInfo.primarySmtpAddress);
                }
                return headers;
            default:
                return assertNever(mailboxInfo.type);
        }
    } else {
        return {};
    }
}

export async function getConnectedAccountHeaders(
    primarySmtpAddress: string
): Promise<{ [headerName: string]: string }> {
    const headers: { [headerName: string]: string } = {};
    const account = getOWAConnectedAccount(primarySmtpAddress);

    if (account) {
        let token = account.token;

        headers[HEADER_ANCHOR_MAILBOX] = account.anchorMailbox;

        if (isPastTime(account.tokenExpiry)) {
            token = await lazyGetAndUpdateRefreshToken.importAndExecute(
                account.accountId,
                primarySmtpAddress
            );
        }

        if (token) {
            let tokenString: string;
            if (account.accountProviderType == 'Outlook') {
                tokenString = `MSAuth1.0 usertoken="${token}", type="MSACT"`;
                headers[HEADER_WEBSESSION_TYPE] = WebSessionType.ExoConsumer.toString();
            } else if (account.accountProviderType == 'Google') {
                tokenString = `Bearer ${token}`;
                headers[HEADER_WEBSESSION_TYPE] = WebSessionType.GMail.toString();
            }

            headers[HEADER_AUTHORIZATION] = tokenString;
        } else {
            return {};
        }
    }

    return headers;
}
